// ngBind
createRefreshDirective("bindRefreshWhen", "ngBind", function(
  scope,
  element,
  attr
) {
  var lastTextContent = null;
  return function refresh(textContent) {
    if (lastTextContent !== textContent) {
      lastTextContent = textContent;
      element[0].textContent = textContent;
    }
  };
});

// ngClass
createRefreshDirective(
  "classRefreshWhen",
  "refreshClass",
  classRefreshService,
  true
);

function createRefreshDirective(
  eventAttr,
  refreshAttr,
  refreshFactory,
  refreshOnInit
) {
  window.app.directive(eventAttr, [
    "$watchRefresh",
    function($watchRefresh) {
      return {
        restrict: "A",
        scope: false,
        link: function(scope, element, attr) {
          $watchRefresh(
            scope,
            attr[eventAttr],
            attr[refreshAttr],
            refreshFactory(scope, element, attr),
            refreshOnInit
          );
        }
      };
    }
  ]);
}

window.app.factory("$watchRefresh", [
  "$parse",
  function($parse) {
    return function linkRefreshFactory(
      scope,
      eventAttr,
      refreshAttr,
      refreshFn,
      refreshOnInit
    ) {
      var events = $parse(eventAttr)({});
      var bindExpr = $parse(refreshAttr);

      for (var idx in events) {
        scope.$on(events[idx], refresh);
      }

      refreshOnInit && refresh();

      function refresh() {
        var value = bindExpr(scope);
        // console.log(refreshAttr, value);
        refreshFn(value);
      }
    };
  }
]);

window.app.factory("$classRefresh", [
  function() {
    return classRefreshService;
  }
]);

function classRefreshService(scope, element, attr) {
  var classList = "";
  return function refresh(classAttr) {
    var newClassList;
    if (typeof classAttr === "string") {
      newClassList = classAttr;
    } else if (typeof classAttr === "function") {
      newClassList = classAttr(scope);
    } else if (Array.isArray(classAttr)) {
      newClassList = classAttr
        .map(function(attr) {
          return !attr || typeof attr === "string"
            ? attr
            : classListFromObject(attr);
        })
        .join(" ");
    } else if (classAttr) {
      newClassList = classListFromObject(classAttr);
    }

    if (classList === newClassList) {
      return;
    }
    classList && element.removeClass(classList);
    newClassList && element.addClass(newClassList);
    classList = newClassList;
  };

  function classListFromObject(classAttr) {
    return Object.keys(classAttr)
      .filter(function(className) {
        return classAttr[className];
      })
      .join(" ");
  }
}



// WEBPACK FOOTER //
// ./src/directives/ngRefreshWhen.js